import type { ReactNode } from "react";
import type { PageBlock } from "@/types/page-block";

type HeaderLayout = "inset" | "overlay";
const BACKGROUNDS = {
  black: "bg-black",
  white: "bg-white",
  whitesmoke: "bg-whitesmoke",
};

function openingBackground(block: PageBlock | undefined) {
  const color =
    block &&
    (("backgroundColor" in block && block.backgroundColor) ||
      ("background" in block && block.background) ||
      ("uiConfiguration" in block && block.uiConfiguration?.backgroundColor));
  return color === "black" || color === "whitesmoke" ? color : "white";
}

/**
 * The opening section owns the surface behind the floating header. Heroes
 * reach the top edge; text/listing openings reserve room in their own color.
 * An explicit override leaves room for future page designs without URL rules.
 */
export function ContentPageSurface({
  firstBlock,
  headerLayout,
  children,
}: Readonly<{
  firstBlock?: PageBlock;
  headerLayout?: HeaderLayout;
  children: ReactNode;
}>) {
  const layout =
    headerLayout ??
    (firstBlock?.__typename === "SectionHero" ||
    firstBlock?.__typename === "HeroSectionSlider"
      ? "overlay"
      : "inset");
  return (
    <main
      className={BACKGROUNDS[openingBackground(firstBlock)]}
      data-header-layout={layout}
    >
      {children}
    </main>
  );
}
